var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"position-relative",attrs:{"id":"appcontainer"}},[_c('b-overlay',{style:({ height: _vm.isLoading ? '100vh' : 'auto' }),attrs:{"show":_vm.isLoading,"opacity":1,"spinner-type":"grow"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }